module.exports = __webpack_public_path__ + "img/data-not-found.cc981b1c.png";